/**
 * 把鼠标/触摸的 Pointer Events 转成归一化输入 { active, x, y } ∈ [-1, 1]。
 * 使用 pointerdown/move/up/cancel 覆盖鼠标和触摸场景。
 */
export class InputController {
  constructor(canvas) {
    this.canvas = canvas;
    this.state = { active: false, x: 0, y: 0 };
    this._pointerId = null;

    this._onDown = this._onDown.bind(this);
    this._onMove = this._onMove.bind(this);
    this._onUp = this._onUp.bind(this);
    this._onCancel = this._onCancel.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);

    canvas.addEventListener('pointerdown', this._onDown);
    canvas.addEventListener('pointermove', this._onMove);
    window.addEventListener('pointerup', this._onUp);
    window.addEventListener('pointercancel', this._onCancel);
    window.addEventListener('blur', this._onBlur);
    canvas.addEventListener('touchmove', this._onTouchMove, { passive: false });
  }

  get() {
    return this.state;
  }

  _normalize(e) {
    const rect = this.canvas.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    const y = ((e.clientY - rect.top) / rect.height) * 2 - 1;
    return { x, y };
  }

  _onDown(e) {
    this._pointerId = e.pointerId;
    try {
      this.canvas.setPointerCapture(e.pointerId);
    } catch {
      /* 某些浏览器可能失败，不阻塞 */
    }
    const { x, y } = this._normalize(e);
    this.state = { active: true, x, y };
  }

  _onMove(e) {
    if (!this.state.active) return;
    if (this._pointerId !== null && e.pointerId !== this._pointerId) return;
    const { x, y } = this._normalize(e);
    this.state = { active: true, x, y };
  }

  _onUp(e) {
    if (this._pointerId !== null && e.pointerId !== this._pointerId) return;
    this._pointerId = null;
    this.state = { active: false, x: 0, y: 0 };
  }

  _onCancel() {
    this._pointerId = null;
    this.state = { active: false, x: 0, y: 0 };
  }

  _onBlur() {
    this._pointerId = null;
    this.state = { active: false, x: 0, y: 0 };
  }

  _onTouchMove(e) {
    e.preventDefault();
  }

  dispose() {
    this.canvas.removeEventListener('pointerdown', this._onDown);
    this.canvas.removeEventListener('pointermove', this._onMove);
    window.removeEventListener('pointerup', this._onUp);
    window.removeEventListener('pointercancel', this._onCancel);
    window.removeEventListener('blur', this._onBlur);
    this.canvas.removeEventListener('touchmove', this._onTouchMove);
  }
}
